export default __webpack_public_path__ + "static/media/node-express-portfolio.ad7bd508.png";